module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.158c0617.woff";